import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _intlMessageformat from "intl-messageformat";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/**
 * Stores a mapping of localized strings. Can be used to find the
 * closest available string for a given locale.
 */

export var MessageDictionary = /*#__PURE__*/function () {
  function MessageDictionary(messages, defaultLocale) {
    _classCallCheck(this, MessageDictionary);

    if (defaultLocale === void 0) {
      defaultLocale = 'en-US';
    }

    this.messages = void 0;
    this.defaultLocale = void 0; // Clone messages so we don't modify the original object.

    this.messages = _babelRuntimeHelpersEsmExtends({}, messages);
    this.defaultLocale = defaultLocale;
  }

  _createClass(MessageDictionary, [{
    key: "getStringForLocale",
    value: function getStringForLocale(key, locale) {
      var strings = this.messages[locale];

      if (!strings) {
        strings = $e73469445899f72bd9d935bbafe76d4$var$getStringsForLocale(locale, this.messages, this.defaultLocale);
        this.messages[locale] = strings;
      }

      var string = strings[key];

      if (!string) {
        throw new Error("Could not find intl message " + key + " in " + locale + " locale");
      }

      return string;
    }
  }]);

  return MessageDictionary;
}();

function $e73469445899f72bd9d935bbafe76d4$var$getStringsForLocale(locale, strings, defaultLocale) {
  if (defaultLocale === void 0) {
    defaultLocale = 'en-US';
  } // If there is an exact match, use it.


  if (strings[locale]) {
    return strings[locale];
  } // Attempt to find the closest match by language.
  // For example, if the locale is fr-CA (French Canadian), but there is only
  // an fr-FR (France) set of strings, use that.
  // This could be replaced with Intl.LocaleMatcher once it is supported.
  // https://github.com/tc39/proposal-intl-localematcher


  var language = $e73469445899f72bd9d935bbafe76d4$var$getLanguage(locale);

  for (var key in strings) {
    if (key.startsWith(language + '-')) {
      return strings[key];
    }
  } // Nothing close, use english.


  return strings[defaultLocale];
}

function $e73469445899f72bd9d935bbafe76d4$var$getLanguage(locale) {
  // @ts-ignore
  if (Intl.Locale) {
    // @ts-ignore
    return new Intl.Locale(locale).language;
  }

  return locale.split('-')[0];
}
/**
 * Formats ICU Message strings to create localized strings from a MessageDictionary.
 */


export var MessageFormatter = /*#__PURE__*/function () {
  function MessageFormatter(locale, messages) {
    _classCallCheck(this, MessageFormatter);

    this.locale = void 0;
    this.messages = void 0;
    this.cache = void 0;
    this.locale = locale;
    this.messages = messages;
    this.cache = {};
  }

  _createClass(MessageFormatter, [{
    key: "format",
    value: function format(key, variables) {
      var message = this.cache[key];

      if (!message) {
        var msg = this.messages.getStringForLocale(key, this.locale);

        if (!msg) {
          throw new Error("Could not find intl message " + key + " in " + this.locale + " locale");
        }

        message = new _intlMessageformat(msg, this.locale);
        this.cache[key] = message;
      }

      var varCopy;

      if (variables) {
        varCopy = Object.keys(variables).reduce(function (acc, key) {
          acc[key] = variables[key] == null ? false : variables[key];
          return acc;
        }, {});
      }

      return message.format(varCopy);
    }
  }]);

  return MessageFormatter;
}();